import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "Flat shipping ₹99 on every order",
  "New arrivals weekly",
  "Crafted in limited quantities",
  "Report issues within 24 hrs",
];

const TopMarquee = () => (
  <div className="bg-primary text-primary-foreground py-2 text-[10px] sm:text-[11px] tracking-[0.18em] sm:tracking-[0.28em] uppercase" data-testid="top-marquee">
    <Marquee gradient={false} speed={28} pauseOnHover>
      {items.concat(items).map((t, i) => (
        <span key={i} className="mx-6 sm:mx-12 inline-flex items-center gap-6 sm:gap-12">
          <span className="opacity-40">✦</span>
          {t}
        </span>
      ))}
    </Marquee>
  </div>
);

export default TopMarquee;

